// src/pages/DerechoMercantilPage.js (MIGRADO A REACT ROUTER)
import React, { useState } from 'react';
// 🛑 IMPORTACIÓN DE useNavigate
import { FiArrowLeft, FiChevronDown, FiChevronUp, FiBriefcase, FiZap, FiFileText } from 'react-icons/fi';
import { useNavigate } from 'react-router-dom'; // ✅ Importado
import '../styles/ServicesCommon.css'; 
import './DerechoMercantilStyles.css';

// Componente reutilizable para el contenido desplegable (Acordeón)
const AccordionItem = ({ title, children }) => {
    const [isOpen, setIsOpen] = useState(false);

    return (
        <div className="accordion-item">
            <button className="accordion-title" onClick={() => setIsOpen(!isOpen)}>
                {title}
                {isOpen ? <FiChevronUp size={20} /> : <FiChevronDown size={20} />}
            </button>
            {isOpen && <div className="accordion-content">{children}</div>}
        </div>
    );
};

// Datos organizados por categoría para el acordeón (MERCANTIL_SECTIONS)
const MERCANTIL_SECTIONS = [
    {
        category: "Constitución y Contratación Empresarial",
        icon: <FiBriefcase size={22} />,
        items: [
            {
                title: "Constitución de Asociaciones Civiles",
                content: `Asesoría legal integral para la creación y formalización de organizaciones sin fines de lucro en Venezuela. Incluye redacción de estatutos, actas y gestión de trámites ante autoridades competentes.`,
            },
            {
                title: "Contratos de Obra",
                content: `Asesoría legal y redacción de contratos de obra, estableciendo plazos, costos, especificaciones técnicas y responsabilidades para proyectos de construcción, manufactura o trabajos específicos.`,
            },
            {
                title: "Documentos de Ventas con Reserva de Dominio",
                content: `Elaboración y asesoría legal en documentos de ventas con cláusulas de reserva de dominio, permitiendo al vendedor mantener la propiedad hasta el pago total, garantizando una operación segura.`,
            },
        ]
    },
    {
        category: "Garantías y Finanzas Mercantiles",
        icon: <FiZap size={22} />,
        items: [
            {
                title: "Constitución de Hipotecas",
                content: `Asesoría legal para garantizar obligaciones financieras afectando un bien inmueble. Asistencia integral en la redacción y formalización de contratos hipotecarios, cumpliendo con la normativa venezolana.`,
            },
            {
                title: "Constitución de Prendas",
                content: `Asesoría legal para garantizar obligaciones afectando bienes muebles. Asistencia en la redacción y formalización de contratos de prenda, brindando seguridad al acreedor.`,
            },
            {
                title: "Constitución de Fianzas",
                content: `Asesoría legal para establecer garantías que aseguren el cumplimiento de obligaciones por parte de un tercero, protegiendo los intereses de nuestros clientes.`,
            },
            {
                title: "Protesto de Cheques y Letras de Cambio",
                content: `Servicio especializado en el procedimiento formal para dejar constancia legal de la falta de pago de cheques y letras de cambio, facilitando las acciones judiciales correspondientes.`,
            },
        ]
    },
    {
        category: "Litigios, Daños y Fraude Procesal",
        icon: <FiFileText size={22} />,
        items: [
            {
                title: "Todo Tipo de Demanda y Defensa en Materia Mercantil",
                content: `Representación legal completa en litigios derivados de actos de comercio, contratos mercantiles, seguros, bancario y cualquier otra controversia en el ámbito mercantil.`,
            },
            {
                title: "Casos de Fraude Procesal",
                content: `Identificación, prevención y defensa contra prácticas engañosas que buscan alterar la verdad en procedimientos judiciales, protegiendo los derechos de nuestros clientes y la integridad del proceso.`,
            },
            {
                title: "Inspecciones y Notificaciones Judiciales",
                content: `Garantizamos el cumplimiento efectivo de los procedimientos legales mediante la realización de inspecciones y la correcta notificación de actos judiciales con máxima precisión y celeridad.`,
            },
            {
                title: "Daños Morales, Materiales y Perjuicios (Demandas y Defensas)",
                content: `Asesoría legal en la reclamación y defensa por perjuicios económicos, emocionales o psicológicos causados por actos ilícitos o incumplimientos contractuales en el ámbito mercantil.`,
            },
        ]
    },
];

// 🛑 ELIMINAMOS setActivePage de las props
const DerechoMercantilPage = () => {
    const navigate = useNavigate(); // ✅ Inicializamos useNavigate

    return (
        <div className="page-container mercantil-page">
            <header className="mercantil-header">
                <FiBriefcase size={40} className="mercantil-icon" />
                <h1>Derecho Mercantil y Corporativo</h1>
                <p className="mercantil-summary">
                    Nuestra firma ofrece una asesoría legal especializada en **Derecho Mercantil** para la constitución, operación y defensa de su empresa. Desde la formalización de contratos y garantías, hasta la litigación de alto nivel y la prevención de fraude procesal.
                </p>
                
                <div className="cta-box">
                    <p>¿Necesitas proteger tu empresa o formalizar una operación mercantil?</p>
                    <button 
                        className="cta-button primary"
                        onClick={() => window.open('https://wa.me/14078738172?text=Quisiera%20asesor%C3%ADa%20en%20Derecho%20Mercantil%20y%20Corporativo.', '_blank')}
                    >
                        Solicitar Asesoría Empresarial
                    </button>
                </div>
            </header>

            <h2 className="section-title">Servicios Clave de Derecho Mercantil</h2>
            
            <div className="accordion-container">
                {MERCANTIL_SECTIONS.map((section, index) => (
                    <div key={index} className="accordion-section-group">
                        <h3 className="section-group-title">
                            {section.icon} {section.category}
                        </h3>
                        {section.items.map((item, i) => (
                            <AccordionItem key={i} title={item.title}>
                                <p>{item.content}</p>
                            </AccordionItem>
                        ))}
                    </div>
                ))}
            </div>

            <footer className="footer-note">
                <p className="note-text">
                    <span className="note-bold">Enfoque:</span> Profesionalismo y eficiencia para salvaguardar sus intereses comerciales y la integridad de sus transacciones.
                </p>
            </footer>

            {/* 🚀 BOTÓN "Volver a Servicios" CORREGIDO */}
            <button className="back-button" onClick={() => navigate('/servicios')}>
                <FiArrowLeft /> Volver a Servicios
            </button>
        </div>
    );
};

export default DerechoMercantilPage;